import { useEffect, useRef, useState } from 'react';
import { subscribeToToasts } from './toastBus';

function ToastProvider({ children }) {
  const [toast, setToast] = useState(null);
  const dismissTimerRef = useRef(null);

  useEffect(() => {
    return () => {
      if (dismissTimerRef.current) {
        clearTimeout(dismissTimerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const unsubscribe = subscribeToToasts((nextToast) => {
      if (dismissTimerRef.current) {
        clearTimeout(dismissTimerRef.current);
      }
      setToast(nextToast);
      dismissTimerRef.current = setTimeout(() => {
        setToast(null);
        dismissTimerRef.current = null;
      }, nextToast.durationMs);
    });

    return unsubscribe;
  }, []);

  return (
    <>
      {children}
      {toast ? (
        <div className="global-toast" role="status" aria-live="polite">
          {toast.message}
        </div>
      ) : null}
    </>
  );
}

export default ToastProvider;
